export default "__VITE_ASSET__dd754ae3__"